import { styled } from '@mui/material';
import { Avatar } from '../Avatar';
import { Checkbox } from '../Checkbox';
export const CheckIconContainer = styled('span')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    paddingRight: '1rem',
    color: theme.palette.primary.dark,
    // '.Mui-focused &': {
    // 	color: theme.palette.common.white,
    // },
}));
export const OptionCheckbox = styled(Checkbox)(({ theme }) => ({
    marginRight: theme.spacing(2),
}));
export const OptionAvatar = styled(Avatar)(({ theme }) => ({
    width: theme.spacing(5),
    height: theme.spacing(5),
    fontSize: theme.spacing(3),
    marginRight: theme.spacing(3),
}));
export const OptionListItem = styled('li')(({ theme }) => ({
    position: 'relative',
    paddingRight: theme.spacing(9),
}));
